<template>
  <div>
    <dialog-conversation-history/>
    <dialog-block-customer/>
    <dialog-create-m-a-d-template/>
    <dialog-update-m-a-d-template/>
    <dialog-m-a-d-template/>
    <dialog-create-quick-response/>
  </div>
</template>

<script>
import DialogConversationHistory from "components/dialog/DialogConversationHistory";
import DialogBlockCustomer from "components/dialog/DialogBlockCustomer";
import DialogCreateMADTemplate from "components/dialog/DialogCreateMADTemplate";
import DialogMADTemplate from "components/dialog/DialogMADTemplate";
import DialogUpdateMADTemplate from "components/dialog/DialogUpdateMADTemplate";
import DialogCreateQuickResponse from "components/dialog/DialogCreateQuickResponse";
export default {
  name: "Index",
  components: {
    DialogUpdateMADTemplate,
    DialogMADTemplate, DialogCreateMADTemplate, DialogBlockCustomer, DialogConversationHistory, DialogCreateQuickResponse},
  comments: {
    DialogConversationHistory: () => import(
        "./DialogConversationHistory"
        ),
    DialogBlockCustomer: () => import(
        "./DialogBlockCustomer"
        ),
    DialogCreateMADTemplate: () => import(
        "./DialogCreateMADTemplate"
        ),
    DialogMADTemplate: () => import(
        "./DialogMADTemplate"
        ),
    DialogUpdateMADTemplate: () => import(
        "./DialogUpdateMADTemplate"
        ),
    DialogCreateQuickResponse: () => import(
        "./DialogCreateQuickResponse"
        )

  }
}
</script>

<style scoped>

</style>
